<script>
import { Pie } from "vue-chartjs";

export default {
    name: "PieChart",
    extends: Pie,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            display: false
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            display: false
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                    }
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const dataset = data.datasets[tooltipItem.datasetIndex];
                            const total = dataset.data.reduce((sum, value) => sum + value, 0);
                            const currentValue = dataset.data[tooltipItem.index];
                            const percentage = total ? ((currentValue / total) * 100).toFixed(1) : 0;
                            return `${data.labels[tooltipItem.index]}: ${percentage}%`;
                        }
                    }
                }
            }
        }
    },
    mounted() {
        const vm = this
        vm.renderChart(vm.data, vm.options);
    },
    watch: {
        data() {
            const vm = this
            vm.renderChart(vm.data, vm.options);
        },
        options() {
            const vm = this
            vm.renderChart(vm.data, vm.options);
        }
    }
};
</script>